module.exports = __webpack_public_path__ + "static/media/App_Store_Menu.77e5672e.svg";